import React from 'react';
import './Createcampaign.css';

const ConversionsUpload: React.FC = () => {
  const handleSubmit = () => {
    // Implement the submit functionality here
    console.log('Uploading Conversions');
  };

  return (
    <div
      className="main_box_style"
      style={{
        padding: '10px 25px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Added shadow
      }}
    >
      <h3>Conversions Upload:</h3>
      <table
        cellPadding={0}
        cellSpacing={0}
        border={0}
        width="100%"
        className="bdv_000000_Text_11"
        style={{ paddingLeft: '20px' }}
      >
        <tbody>
          <tr>
            <td valign="top">
              <table
                cellPadding={7}
                cellSpacing={0}
                border={0}
                width="100%"
                className="bdv_000000_Text_11"
              >
                <tbody>
                  <tr>
                    <td align="left">
                      Conversions Upload allows you to manually upload conversions that were not reported during the last 30 days.
                      <br />
                      <br />
                      You may want to use this feature in the following use cases:
                      <ol>
                        <li> You can't implement server to server postback and you can only report conversions manually </li>
                        <li>
                          You wish to correct any discrepancies in conversion revenue between BidVertiser and your own tracking software
                        </li>
                      </ol>
                      Similar to receiving a postback from your tracking software, you will need to submit a valid ClickID, represented by the{' '}
                      <code>{`{BV_CLICKID}`}</code> Macro, and a matching revenue of the specific ClickID.
                      <br />
                      <br />
                      To upload conversions, enter one entry per line in the following text box.
                      <br />
                      Each line should contain the ClickID and the revenue (payout), separated by a comma.
                      <br />
                      (Maximum number of conversions in each batch upload is limited to 5000)
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <table cellPadding={0} cellSpacing={0} border={0} className="bdv_000000_Text_11">
                        <tbody>
                          <tr>
                            <td></td>
                          </tr>
                          <tr>
                            <td>
                              <textarea
                                name="conversions"
                                style={{ width: '500px', height: '500px' }}
                                placeholder={`BV_CLICKID_1, REVENUE_1\nBV_CLICKID_2, REVENUE_2\nBV_CLICKID_3, REVENUE_3\n.\n.\n.`}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td align="center">
                              <br />
                              <input type="hidden" name="updateConversions" value="" />
                              <input
                                type="button"
                                className="function-button"
                                name="updateConversionsButton"
                                value="Upload Conversions"
                                onClick={handleSubmit}
                                title="Postback URL must be activated"
                                disabled
                              />
                              <br />
                              <a href="https://my.bidvertiser.com/bdv/BidVertiser/BidVertiserA/bdv_adv_Performance_Tracker.dbm?ID_Token=P650P103N443799&amp;AID=710749&amp;requesttimeout=300">
                                Postback URL
                              </a>{' '}
                              must be activated
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <strong>Important Notes:</strong>
                      <br />
                      1. You can only upload conversions that were generated during the last 30 days
                      <br />
                      2. If the Click ID is already associated with a conversion (due to either manual or postback conversion that was received) - it will be ignored!
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ConversionsUpload;
